import React, { useContext } from 'react';
import styled from 'styled-components';
import { Button } from 'components/Button';
import { Tooltip } from 'components/Tooltip';
import { IListing } from '@bb/domain/dist/types';
import { AuthContextType } from 'contexts';
import { TOOLTIP_OPTIONS } from './constants';

type RegisterOfferButtonType = {
  isDisabledBtns: boolean;
  listing: IListing & { id: string };
  isAgent: boolean;
  isListingAgent: boolean;
  isUnverified: boolean;
  org: AuthContextType['auth']['org'];
  handleBookModal: () => void;
};

export const RegisterOfferButton = ({
  isDisabledBtns,
  listing,
  isAgent,
  isListingAgent,
  isUnverified,
  org,
  handleBookModal,
}: RegisterOfferButtonType) => (
    <Tooltip title={isDisabledBtns && TOOLTIP_OPTIONS.offer}>
      <div>
        <StyledRegisterOfferButton
          disabled={isDisabledBtns}
          onClick={handleBookModal}
        >
          <a
            href={
              org &&
              org.features.includes('APPOINTMENT') &&
              !(isAgent && !isListingAgent && isUnverified)
                ? `#/listing/${listing.id}/offer/new?view=listing`
                : undefined
            }
          >
            Register offer
          </a>
        </StyledRegisterOfferButton>
      </div>
    </Tooltip>
  );

const StyledRegisterOfferButton = styled(Button)`
  && {
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    border-radius: 7px;
  }
`;
